async function pushIdsInGtag(){

    try {
      const response = await fetch("/cart.js");

      const data = await response.json();

      const ids = getProductIdsInCart(data);

      console.log(ids);

      gtag('event', 'conversion', {

        'allow_custom_scripts': true,

        'u2': ids,

        'send_to': 'DC-11551221/check0/wande0+standard'

      });

    } catch(err) {

      console.log('error',err);

    }

}



function getProductIdsInCart(data){

    return data.items.map(item=>item.id);

}



var visitedCheckout = JSON.parse(window.sessionStorage.getItem("visited-checkout"));

var paidCheckout = JSON.parse(window.sessionStorage.getItem("paid-checkout"));

var abandonedCheckoutPosted = JSON.parse(window.sessionStorage.getItem("abandoned_checkout_posted"));



if(visitedCheckout === null){

    window.sessionStorage.setItem("visited-checkout",false);

    visitedCheckout = false;

}

if(paidCheckout === null){

    window.sessionStorage.setItem("paid-checkout",false);

    paidCheckout = false;

}

if(abandonedCheckoutPosted === null){

    window.sessionStorage.setItem("abandoned_checkout_posted",false);

    abandonedCheckoutPosted = false;

}

if(visitedCheckout === true && paidCheckout === false && abandonedCheckoutPosted === false){

    console.log("gtag trigger");

    pushIdsInGtag();

    window.sessionStorage.setItem("abandoned_checkout_posted",true);

}

console.log('visitedCheckout',visitedCheckout);

console.log('paidCheckout',paidCheckout);

console.log('abandonedCheckoutPosted',abandonedCheckoutPosted);



function resetSession(){

   console.log('Reset session!');
   
   window.sessionStorage.setItem("visited-checkout",false);
   
   window.sessionStorage.setItem("paid-checkout",false);
   
   window.sessionStorage.setItem("abandoned_checkout_posted",false);
   
   gamificationText();
   cartGamificationPromotions();
}

function setSessionWhenCustomerCheckout(){

   console.log("Set session when customer is in checkout page");

    window.sessionStorage.setItem("visited-checkout",true);

    window.sessionStorage.setItem("abandoned_checkout_posted",false);

}

function setSessionWhenCustomerFinishCheckout(){

    console.log("Set session when customer is in thank you page");

    window.sessionStorage.setItem("paid-checkout",true);

    window.sessionStorage.setItem("visited-checkout",false);

    window.sessionStorage.setItem("abandoned_checkout_posted",false);

 }